module.exports = __webpack_public_path__ + "static/media/page3_sama3.81b69dc8.wav";